export default __webpack_public_path__ + "static/media/img15.4be7e489.png";